import { useSelector } from 'react-redux';
import { UserPermission } from 'src/services/users/userPermissions';
import { AppState } from 'src/store/Store';

export const usePermissions = (permission: string | string[]) => {
  const permissions = useSelector((state: AppState) => state.permissionsReducer.permissions);
  if (!permissions?.length) {
    return false;
  }
  const required = Array.isArray(permission) ? permission : [permission];
  return permissions.some((perm: UserPermission) => required.includes(perm?.name));
};
